"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Row = void 0;

var _clearfix = require("../../styles/clearfix");

var _grid = require("../../styles/grid");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

/**
 * Module dependencies.
 */

/**
 * Set row margin.
 */
function setRowMargin(_ref) {
  var theme = _ref.theme;
  var _theme$grid = theme.grid,
      gutter = _theme$grid.gutter,
      unit = _theme$grid.unit;
  return (0, _styledComponents.css)(["margin-left:-", "", ";margin-right:-", "", ";"], gutter, unit, gutter, unit);
}
/**
 * `Row` component.
 */


var Row = _styledComponents.default.div.withConfig({
  displayName: "row__Row",
  componentId: "gu63vd-0"
})(["", " ", " ", ""], _clearfix.clearfix, setRowMargin, _grid.setDebugStyle);
/**
 * Export `Row` component.
 */


exports.Row = Row;
var _default = Row;
exports.default = _default;